<!--
/**
* @name: List.vue
* @description: 消息列表页面
* @author: 杨波
* @create: 2020/11/05 11:11:37
* @update: 2020/1/05 11:11:37
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择队列名称" block clearable v-model="para.queueName">
          <k-option v-for="item in queueNameList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-input placeholder="请输入消息标识" block clearable v-model="para.tagNo"></k-input>
      </y-query-item>
      <y-query-item :class="css.inputW">
        <k-select placeholder="请选择状态" block clearable v-model="para.isSuccess">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="createDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择创建时间查询" style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="queueMessageList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination v-if="queueMessageList && queueMessageList.length" :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import { NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_PAGES, NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_RETRY } from "@/assets/modules/apiList";
const initPara = () => ({
  queueName: "",
  tagNo: "",
  isSuccess: "",
  createStartTime: "",
  createEndTime: "",
  pageSize: 15,
  pageCurrent: 1,
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      createDate: "",
      queueNameList: [
        {
          value: "EARNING_CREATE",
          label: "收益创建",
        },
        {
          value: "EARNING_CONFIRM",
          label: "收益确认",
        },
        {
          value: "EARING_CANCEL",
          label: "收益取消",
        },
        {
          value: "GOODS_SALE_ADD",
          label: "商品增加销量",
        },
        {
          value: "ORDER_RECEIVE_CONFIRM",
          label: "延时自动确认收货",
        },
        {
          value: "ORDER_NESTLE_CANCEL_DELAY",
          label: "延时自动取消订单",
        },
        {
          value: "ORDER_CREATE",
          label: "推送订单到订单中心",
        },
        {
          value: "PAY_CREATE",
          label: "推送支付单到订单中心",
        },
        {
          value: "ORDER_CANCEL",
          label: "推送订单取消状态到订单中心",
        },
        {
          value: "ORDER_CANCEL_DELAY",
          label: "延时推送订单取消状态到订单中心",
        },
      ],
      statusList: [
        {
          value: 1,
          label: "成功",
        },
        {
          value: 0,
          label: "失败",
        },
      ],
      queueMessageList: [],
      total: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    initColumns() {
      return [
        {
          name: "ID",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "队列名称",
          field: "queueName",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.queueNameList.length; i++) {
              if (row.queueName == this.queueNameList[i].value) {
                temp = this.queueNameList[i].label;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "消息标识",
          field: "tagNo",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "尝试次数",
          field: "tryCount",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "20px",
          },
        },
        {
          name: "是否成功",
          field: "isSuccess",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            return <div>{row.isSuccess ? "成功" : "失败"}</div>;
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: { textAlign: "center", width: 130 },
        },
        {
          name: "操作",
          field: "action",
          style: {
            textAlign: "center",
            width: 50,
          },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                详情
              </a>
            );
            const retrytButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onRetry(row);
                }}
              >
                重试
              </a>
            );
            if (row.isSuccess) {
              return <div>{previewButton}</div>;
            } else {
              return (
                <div>
                  {previewButton}&#12288;{retrytButton}
                </div>
              );
            }
          },
        },
      ];
    },
    //分页查询数据
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getQueueMessageList();
    },
    changeDate(date) {
      this.createDate = date;
    },
    //条件查询列表数据
    onSearch() {
      this.para.pageCurrent = 1;
      this.getQueueMessageList();
    },
    //重置查询条件
    onReset() {
      this.para = initPara();
      this.createDate = "";
      this.getQueueMessageList();
    },
    //获取列表数据
    getQueueMessageList() {
      let { para } = this;
      para.createStartTime = this.createDate && this.createDate.length > 0 ? this.createDate[0] : "";
      para.createEndTime = this.createDate && this.createDate.length > 0 ? this.createDate[1] : "";
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_PAGES,
        para,
      }).then((res) => {
        this.queueMessageList = res.pageList || [];
        this.total = res.total;
      });
    },
    //消息重试
    onRetry(row) {
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_MQ_SEND_TASK_RETRY,
        para: { id: row.id },
      }).then((res) => {
        tip("操作成功");
        this.getQueueMessageList();
      });
    },
    //查看消息列表详情
    onView(row) {
      const { id } = row;
      this.$controller.open({
        name: "messageDetail",
        query: {
          refresh: new Date() - 0,
          id,
        },
      });
    },
  },
  created() {
    this.getQueueMessageList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getQueueMessageList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 250px;
}
</style>
